const baseURL = 'https://multi.appoyandote.com/';

export default baseURL;
